import CustomerPartNumbersReducer from "@auer-steel/Store/Data/CustomerPartNumbers/CustomerPartNumbersReducer";
import { CustomerPartNumbersState } from "@auer-steel/Store/Data/CustomerPartNumbers/CustomerPartNumbersState";
import AuerInvoiceHistoryReducer from "@auer-steel/Store/Pages/InvoiceHistory/AuerInvoiceHistoryReducer";
import AuerInvoiceHistoryState from "@auer-steel/Store/Pages/InvoiceHistory/AuerInvoiceHistoryState";
import MyPartNumbersReducer from "@auer-steel/Store/Pages/MyPartNumbers/MyPartNumbersReducer";
import MyPartNumbersState from "@auer-steel/Store/Pages/MyPartNumbers/MyPartNumbersState";
import PayInvoiceReducer from "@auer-steel/Store/Pages/PayInvoice/PayInvoiceReducer";
import PayInvoiceState from "@auer-steel/Store/Pages/PayInvoice/PayInvoiceState";
import AuerRequestRmaState from "@auer-steel/Store/Pages/RequestRma/AuerRequestRmaState";
import AuerRequestRmaReducer from "@auer-steel/Store/Pages/RequestRma/RmaFormReducer";
import RmaHistoryReducer from "@auer-steel/Store/Pages/RmaHistory/RmaHistoryReducer";
import RmaHistoryState from "@auer-steel/Store/Pages/RmaHistory/RmaHistoryState";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

import AuerUserListReducer from "@auer-steel/Store/Pages/UserList/AuerUserListReducer";
import AuerUserListState from "@auer-steel/Store/Pages/UserList/AuerUserListState";

import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

export type AuerState = {
    myPartNumbers: MyPartNumbersState;
    customerPartNumbers: CustomerPartNumbersState;
    rmaHistory: RmaHistoryState;
    auerRequestRma: AuerRequestRmaState;
    auerInvoiceHistory: AuerInvoiceHistoryState;
    payInvoice: PayInvoiceState;
	auerUserList: AuerUserListState;
} & ApplicationState;

(reducers as any).myPartNumbers = MyPartNumbersReducer;
(reducers as any).customerPartNumbers = CustomerPartNumbersReducer;
(reducers as any).rmaHistory = RmaHistoryReducer;
(reducers as any).auerRequestRma = AuerRequestRmaReducer;
(reducers as any).auerInvoiceHistory = AuerInvoiceHistoryReducer;
(reducers as any).payInvoice = PayInvoiceReducer;
(reducers as any).auerUserList = AuerUserListReducer;

type AuerReducers = typeof reducers;

export type AuerActions = AnyAction | Parameters<AuerReducers[keyof AuerReducers]>[1];
